/**
 * Wraps a value within a range [min, max).
 * Handles negative values correctly (unlike plain modulo).
 */
export const wrap = (min, max, v) => {
  const range = max - min;
  return ((((v - min) % range) + range) % range) + min;
};
